import { TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { RoundTableSection } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/roundTable/components/roundTableSection/RoundTableSection'
import { RoundTableSectionMark } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/roundTable/components/roundTableSectionMark/RoundTableSectionMark'
import { useCallback, useMemo } from 'react'

import { EditableArea } from 'core/components/shared/ui/EditableArea'
import { MultiInputsControl } from 'partner360/components/multiInputsControl'

import { Title } from '../../../ui/styledComponents/title/Title'

import styles from './CompanyAtGlance.module.scss'

interface IProps {
  updateFormData?: (field: string) => (value: string) => void
  updateCompanyAtGlanceInputs: (data: TComplexSectionData) => void
  formIsFinalized: boolean
  companyAtGlanceInputs?: string[]
  oldCompanyAtGlance?: string
  titleText: string
}

export const CompanyAtGlance = ({
  formIsFinalized,
  updateFormData,
  companyAtGlanceInputs,
  oldCompanyAtGlance,
  updateCompanyAtGlanceInputs,
  titleText,
}: IProps) => {
  const onChange = useCallback(
    async (value: string) => {
      if (updateFormData) {
        const safeValue =
          value
            ?.replace(/class="\\&quot;editor-block\\&quot;"/g, '')
            ?.replace(/class="\\&quot;editor-block-content\\&quot;"/g, '') || '' //remove non safe json data

        updateFormData('Info')(safeValue)
      }
    },
    [updateFormData]
  )

  const isNewVersion = useMemo(() => {
    return Boolean(companyAtGlanceInputs)
  }, [companyAtGlanceInputs])

  if (isNewVersion) {
    return (
      <RoundTableSection>
        <div>
          <Title
            variant="withBackground"
            text={titleText}
            rightContent={<RoundTableSectionMark />}
          />
          <MultiInputsControl
            showBottomControl={false}
            values={companyAtGlanceInputs || []}
            onChange={updateCompanyAtGlanceInputs}
            isTextArea
          />
        </div>
      </RoundTableSection>
    )
  }

  return (
    <div className={styles.root}>
      <Title variant="withBackground" text={titleText} />
      <EditableArea
        disableBorder
        text={oldCompanyAtGlance || ''}
        onChange={onChange}
        useBlockMode
        multiline
        emptyText={'Show example'}
        hideImageActions
        multilineOptions={['bulletedList', 'numberedList']}
        disableViewModeChange
        disabled={formIsFinalized}
      />
    </div>
  )
}
